/**
 * TECNILAND - ProtectedRoute Component
 * HOC para proteger rutas que requieren autenticación
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * ProtectedRoute - Protege rutas que requieren usuario autenticado
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos a renderizar
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Mientras verifica la autenticación, mostrar loading
  if (loading) {
    return (
      <div style={{
        minHeight: 'calc(100vh - 70px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0e27'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
          color: '#cccccc'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid rgba(0, 255, 0, 0.2)',
            borderTopColor: '#00ff00',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <span>Verificando autenticación...</span>
          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  // Si no está autenticado, redirigir al home
  if (!isAuthenticated) {
    // Guardar la ubicación actual para redirigir después del login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si está autenticado, renderizar los hijos
  return children;
};

export default ProtectedRoute;
